/**
 * on document ready...
 */
$(function () {
    /**
     * define the datalayer, if it hasn't been defined yet create an empty array.
     */
    var dataLayer = window.dataLayer = window.dataLayer || [];
    
    // put the cookies in a variable so we can fetch it from cache
    function getCookieValue(a, b) {
        b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }
    
   
    /**
     * We need to send the visitor type to the datalayer so, based on the cookie value
     * we will push the value to the datalayer.
     */
    var setCustomerObject = function setCustomerObject() {
         
        // check the cookie and set the customertype
        var isBusinessCookieVal = getCookieValue('isBusiness'),
            customerType = (isBusinessCookieVal === 'true') ? 'business' : 'consumer';

        // create the object
        var userInfo = {
            'userInfo' : {
                'customerType': customerType
            }
        }

        // push it to the dataLayer
        dataLayer.push(userInfo);
    }

    // call the function
    setCustomerObject();
})